// Fila de toasts (erros de consulta/mutação com correlationId — Parte 14.2/14.5). Textos são resolvidos na renderização.
import { create } from 'zustand';

export type ToastKind = 'error' | 'info';

export interface ToastItem {
  readonly id: string;
  readonly kind: ToastKind;
  /** `errorCode` estável (traduzido por `errors:codes.*`); `null` para falha de rede. */
  readonly errorCode: string | null;
  readonly correlationId: string | null;
  /** Título já localizado pelo servidor (ProblemDetails.title), quando existir. */
  readonly serverTitle: string | null;
  readonly createdAt: number;
}

export interface ToastStore {
  readonly toasts: readonly ToastItem[];
  readonly push: (toast: Omit<ToastItem, 'id' | 'createdAt'>) => string;
  readonly dismiss: (id: string) => void;
  readonly clear: () => void;
}

const MAX_TOASTS = 4;

let counter = 0;
function nextId(): string {
  counter += 1;
  return `toast-${String(counter)}`;
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  push: (toast) => {
    const id = nextId();
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id, createdAt: Date.now() }].slice(-MAX_TOASTS),
    }));
    return id;
  },
  dismiss: (id) => {
    set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) }));
  },
  clear: () => {
    set({ toasts: [] });
  },
}));
